import { render, staticRenderFns } from "./StudentExamSeatMap.vue?vue&type=template&id=e25a54ca&scoped=true"
import script from "./StudentExamSeatMap.vue?vue&type=script&lang=js"
export * from "./StudentExamSeatMap.vue?vue&type=script&lang=js"
import style0 from "./StudentExamSeatMap.vue?vue&type=style&index=0&id=e25a54ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25a54ca",
  null
  
)

export default component.exports